export const servicesData = [
  {
    id: 'ai-solutions',
    icon: '🤖',
    title: 'AI Solutions',
    tagline: 'Turn conversation into conversion and data into destiny.',
    description: 'Imagine having a brilliant assistant for every customer, 24/7. Our AI chatbots deliver instant, human-like support that delights users and frees up your team. But it doesn\'t stop there. We harness AI to analyze your data, predict trends, and reveal the hidden opportunities that will propel your business into the future.',
    features: ['Custom AI Chatbots', 'Predictive Analytics', 'Machine Learning Models', 'Natural Language Processing', 'Data-driven Automation'],
    category: 'AI & Data',
    visualType: 'ai'
  },
  {
    id: 'data-analytics',
    icon: '📊',
    title: 'Data Analytics',
    tagline: 'Stop guessing. Start knowing. Make decisions with absolute clarity.',
    description: 'Your data is telling a story. We help you read it. We transform seas of raw numbers into stunning, intuitive dashboards that give you a real-time pulse of your business. Track KPIs, understand customer behavior, and seize opportunities before your competitors even see them.',
    features: ['Business Intelligence Dashboards', 'Data Visualization', 'ETL Pipelines', 'Data Warehousing', 'Performance Metrics'],
    category: 'AI & Data',
    visualType: 'analytics'
  },
  {
    id: 'web-development',
    icon: '💻',
    title: 'Web Development',
    tagline: "Your website isn't a brochure. It's a 24/7 sales machine.",
    description: 'In the digital world, your website is your #1 employee. We build blazing-fast, visually captivating, and highly secure web applications that do more than just exist—they perform. From engaging users to driving sales, we build the platform your business deserves.',
    features: ['Full-Stack Development', 'Responsive UI/UX Design', 'API Integration', 'Progressive Web Apps (PWAs)', 'Performance Optimization'],
    category: 'Development',
    visualType: 'web'
  },
  {
    id: 'mobile-app-development',
    icon: '📱',
    title: 'Mobile App Development',
    tagline: 'Place your business directly in your customer’s pocket.',
    description: 'An app is the most direct connection you can have with your customers. We create beautiful, intuitive, and powerful mobile experiences for iOS and Android that boost engagement, build loyalty, and open up new revenue streams.',
    features: ['Native iOS & Android Apps', 'Cross-Platform (Hybrid) Apps', 'UI/UX for Mobile', 'App Store Deployment', 'Push Notifications'],
    category: 'Development',
    visualType: 'mobile'
  },
  {
    id: 'custom-software',
    icon: '⚙️',
    title: 'Custom Software',
    tagline: 'If you can dream it, we can build it. Software that works your way.',
    description: 'Why force your unique process into a generic box? We build custom software from the ground up, perfectly tailored to your workflow. Eliminate inefficiencies, automate tedious tasks, and empower your team with a tool that feels like it was made just for them—because it was.',
    features: ['Bespoke Application Design', 'Workflow Automation', 'Scalable Architecture', 'Legacy System Modernization', 'In-depth Requirement Analysis'],
    category: 'Development',
    visualType: 'consulting' // Uses a generic 'problem-to-solution' visual
  },
  {
    id: 'crm-solutions',
    icon: '👥',
    title: 'CRM Solutions',
    tagline: 'Build unbreakable relationships. Not just another contact list.',
    description: 'We go beyond the standard CRM. For HealthTech, we build secure, compliant patient management systems. For EdTech, we create platforms to track student success. For vendors, we streamline supply chains. We build the relationship engine that powers your specific industry.',
    features: ['Industry-Specific Workflows', 'Sales & Lead Management', 'Compliance & Security', 'Third-Party Integrations', 'Custom Reporting'],
    category: 'Platforms',
    visualType: 'crm'
  },
  {
    id: 'e-commerce-platforms',
    icon: '🛒',
    title: 'E-commerce',
    tagline: "Create a shopping experience so seamless, customers can't help but buy.",
    description: 'Turn browsers into buyers with a world-class e-commerce platform. We handle everything from stunning product displays to secure, one-click checkouts, creating an online store that not only looks amazing but is optimized for maximum conversion.',
    features: ['Custom Storefront Design', 'Secure Payment Gateways', 'Inventory Management', 'Order Processing', 'SEO for E-commerce'],
    category: 'Platforms',
    visualType: 'ecommerce'
  },
  {
    id: 'iot-systems',
    icon: '💡',
    title: 'IoT Systems',
    tagline: 'Give your physical world a digital brain. Real-time control is here.',
    description: "Imagine knowing exactly what's happening, anywhere, anytime. We connect your devices—from farm sensors to vehicle fleets—to a central, intelligent platform. Optimize resources, prevent problems before they happen, and operate with a level of insight you never thought possible.",
    features: ['Real-time Data Streaming', 'Device & Sensor Integration', 'Remote Control & Automation', 'Secure IoT Networks', 'Data Visualization'],
    category: 'Platforms',
    visualType: 'iot'
  },
  {
    id: 'cyber-security',
    icon: '🛡️',
    title: 'Cyber Security',
    tagline: 'Your fortress in a world of digital threats. We are your shield.',
    description: 'One breach can undo years of hard work. Our proactive cyber security services are your 24/7 watchtower. We identify vulnerabilities before they can be exploited, monitor for threats, and create a resilient security posture that lets you operate with confidence and peace of mind.',
    features: ['Vulnerability Assessment', 'Penetration Testing', '24/7 Threat Monitoring', 'Security Audits & Compliance', 'Incident Response'],
    category: 'Services',
    visualType: 'security'
  },
  {
    id: 'it-consulting',
    icon: '🤝',
    title: 'IT Consulting & Support',
    tagline: 'Your vision needs a strategy. Your strategy needs an expert.',
    description: 'Technology is more than just tools—it\'s a competitive advantage. We act as your strategic partner, creating a technology roadmap that aligns perfectly with your business goals. Combined with our 24/7 support, we ensure your IT is not a cost center, but a growth driver.',
    features: ['Strategic IT Planning', 'Architecture Review', '24/7 Helpdesk Support', 'Proactive System Monitoring', 'Digital Transformation'],
    category: 'Services',
    visualType: 'consulting'
  },
  {
    id: 'tech-resources',
    icon: '🧑‍💻',
    title: 'Tech Resources on Contract',
    tagline: 'The talent you need, exactly when you need it. Scale instantly.',
    description: "Your next big project can't wait for a long hiring process. We provide elite tech talent on demand. Augment your team with our vetted developers, project managers, and analysts to hit your deadlines and launch your next big thing, faster.",
    features: ['On-demand Developers', 'Project Managers & Scrum Masters', 'QA & Testing Experts', 'Flexible Engagement Models', 'Rapid Onboarding'],
    category: 'Services',
    visualType: 'consulting'
  },
  {
    id: 'manufacturing-mes',
    icon: '🏭',
    title: 'Manufacturing Execution System (MES)',
    tagline: 'Real-time visibility into every machine, every process, every moment.',
    description: 'Transform your factory floor into a data-driven powerhouse. Our MES solutions provide real-time monitoring of production lines, quality control, inventory tracking, and equipment performance. Reduce downtime, optimize workflows, and make decisions based on live data, not yesterday\'s reports.',
    features: ['Real-time Production Monitoring', 'Quality Control & Traceability', 'Equipment Performance Analytics', 'Inventory & Material Tracking', 'Work Order Management'],
    category: 'Manufacturing',
    visualType: 'analytics'
  },
  {
    id: 'industry-4-0',
    icon: '⚙️',
    title: 'Industry 4.0 Solutions',
    tagline: 'The smart factory revolution starts here. Connect, analyze, optimize.',
    description: 'Embrace the future of manufacturing with Industry 4.0 technologies. We integrate IoT sensors, AI analytics, and cloud computing to create intelligent manufacturing systems. Predictive maintenance, automated quality control, and seamless supply chain integration—all working together to maximize efficiency and minimize waste.',
    features: ['IoT Sensor Integration', 'Predictive Maintenance', 'Digital Twin Technology', 'Smart Supply Chain', 'Automated Quality Assurance'],
    category: 'Manufacturing',
    visualType: 'iot'
  },
];
